export default build =>
    build.mutation({
        query(payload) {
            console.log("payload indelete lesson",payload)
            return {
                url: '/course/deleteCouponCode',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allCouponCodes'],
       
    })
